export const DEBOUNCE_DEFAULT_TIME = 300;

export const TEST_ID = 'singleSelectPanel';

export const SKELETON_LINES = 8;
